/**
 * 現在のURLからJSONを取得する
*/
async function getProduct() {
  const productUrl = `//${window.location.host}${window.location.pathname}`;
  // ネットワークエラーやページ離脱による fetch 中断を unhandledrejection にしない
  // (null を返せば呼び出し側の !product ガードが履歴登録をスキップする)
  try {
    const response = await fetch(`${productUrl}.json`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
    });
    if (!response.ok) {
      return null;
    }

    const product = await response.json();

    return product.product;
  } catch (e) {
    return null;
  }
}

async function main() {
  // js-cookie が読み込めていない場合(読込失敗・順序異常)は履歴登録をスキップ
  if (typeof Cookies === "undefined") return;
  const product = await getProduct();
  if (!product) return;
  const cookieKey = "product_history";
  /** @type string | undefined */
  const productHistory = Cookies.get(cookieKey);

  /**
   * 指定したIDをクッキーに保存する
   *
   * @param {{ id: number, handle: string }} item
   * @param {{ id: number, handle: string }[]} products
   * @param boolean isFirst
   *
   * @returns void
   */
  function setCookies(item, products = []) {
    Cookies.set(cookieKey, JSON.stringify([item, ...products]), { expires: 7 });
  }

  if (productHistory) {
    /** @type Array<{ id: number, handle: string }> */
    const products = JSON.parse(productHistory);
    if (!products.some((item) => item.id === product.id)) {
      setCookies({ id: product.id, handle: product.handle }, products);
    } else {
      const filteredProducts = products.filter((item) => item.id !== product.id);
      setCookies({ id: product.id, handle: product.handle }, filteredProducts);
    }
  } else {
    setCookies({ id: product.id, handle: product.handle });
  }
}

main();